import { API_BASE } from '../config.js';

// Small fetch wrapper used to stop hand-rolling credentials/headers/error-parsing
// on every call site. Not a full migration of every existing fetch() in the app —
// see the recommendation this addresses for scope — but new/touched code should
// use this instead of raw fetch().
async function request(path, { method = 'GET', body, headers, ...rest } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    credentials: 'include',
    headers: {
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
    ...rest,
  });

  let data = null;
  try { data = await res.json(); } catch { /* empty or non-JSON body */ }

  if (!res.ok) {
    throw new Error(data?.error || `Serverio klaida (${res.status})`);
  }
  return data;
}

export const apiGet = (path, opts) => request(path, { ...opts, method: 'GET' });
export const apiPost = (path, body, opts) => request(path, { ...opts, method: 'POST', body });
export const apiPut = (path, body, opts) => request(path, { ...opts, method: 'PUT', body });
export const apiPatch = (path, body, opts) => request(path, { ...opts, method: 'PATCH', body });
export const apiDelete = (path, opts) => request(path, { ...opts, method: 'DELETE' });
